// @ai-generated 2026-07-21T03:45:01+00:00 by philipp.kammerer@synqony.com using claude-fable-5
import { useMessagesRepository } from '@Hooks/useRepository';
import { type EnumNotificationModule } from '@Model';
import { NotificationSettingsRepository } from '@Repositories/Messages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useResetNotificationSettings() {
    const settings = useMessagesRepository(NotificationSettingsRepository);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (module?: EnumNotificationModule) => settings.reset(module),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['notificationSettings'] });
            // Resetting can unmute types, which changes the server-side filtered list and count.
            void queryClient.invalidateQueries({ queryKey: ['notifications'] });
        },
    });
}
